import { FC } from "react";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from "@mui/material/Avatar";
import Popover from "@mui/material/Popover";
import Divider from '@mui/material/Divider';
import { Cached, ExitToApp, GetApp } from '@mui/icons-material';
import { useObservable } from "src/framework/store/storeUtil";
import { BehaviorSubject } from "rxjs";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { LocalStorage } from "src/framework/commons";
import { EasyDataGridStore } from "../../base/EasyDataGrid/store";
import api from "src/framework/providers/api";
import { IconButton, ListItemButton, Toolbar, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import theme from "src/theme/light";
import "./styles.css";
import { doLogOutContaUnica, permissoes$ } from "src/framework/store/LoginStore";
import { confirmationDialog } from "../../commons/dialogs/Confirmation/store";

export interface UserInfo {
  name: string;
  email?: string;
  icon?: string | null;
  image?: string;
}

export interface UserParams {
    data: UserInfo;
    onChange: Function;
    element: HTMLButtonElement | null;
}

export const authUser$ = new BehaviorSubject<any>(null);

const MenuUser: FC<UserParams> = ({ data, element, onChange }) => {
  const authUser = useObservable(authUser$);
  const open = Boolean(element);
  const id = open ? 'simple-popover' : undefined;
  const avatarName = data.name.match(/(\b\S)?/g)?.join("")?.match(/(^\S|\S$)?/g)?.join("").toUpperCase();

  const ProdutosDataGridStore = new EasyDataGridStore(api);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  ProdutosDataGridStore.setPaths({
    create: "/produtos/exportar",
    delete: "/produtos/exportar",
    list: "/produtos/exportar",
    read: "/produtos/exportar",
    update: "/produtos/exportar",
    cache: "/produtos/exportar",
  });
  
  const handleClose = (value: string) => {
    onChange(null);
  };

  const cleanCache = () => {
    document.location.reload();
  };

  const handleExport = () => {
    ProdutosDataGridStore.export("Kits-Loja-Export");
  };


  const onLogout = () => {
    confirmationDialog.setup({
      content: "Deseja sair da plataforma?",
      title: "Sair",
      onConfirmation: async () => {
        const redirectURL = await doLogOutContaUnica()
        if (redirectURL) {
          LocalStorage.remove("solar.token");
          window.location.href = redirectURL
        }
      },
      onClose: () => confirmationDialog.close(),
    });
    confirmationDialog.open();
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={element}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      anchorReference={isMobile ? "none" : "anchorEl"}

      PaperProps={{
        style: isMobile
        ? {
            position: "fixed",
            top: 0,
            right: 0,
            width: "80vw",
            height: "100vh",
            minHeight: "100%",
            borderRadius: 0,
            boxShadow: theme.shadows[16],
            transition: "transform 0.3s ease-out",
            background: "#fff",
          }
        : {},
      }}
    >
      <Box>
         {isMobile && (
          <Toolbar
            style={{
              alignItems: "center",
              justifyContent: "flex-end",
              borderBottom: "1px solid #ddd",
              background: "#fff",
              height: 64, 
            }}
          >
            <IconButton edge="end" color="inherit" onClick={() => onChange(null)} size="large">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        )}

        <Box className="box">
          <Avatar>{avatarName}</Avatar>
          <Box className="box-info">
            <ListItemText className="title-info" primary={data?.name} />
            <ListItemText className="text-info" primary={data?.email} />
            <ListItemText className="text-info" primary={authUser?.role} />
          </Box>
        </Box>

        <Divider />
        {isMobile && <br />}
        
        <Box>
          <ListItem disablePadding>
            <ListItemButton onClick={cleanCache}>
              <ListItemIcon>
                <Cached />
              </ListItemIcon>
              <ListItemText className="text-menu" primary="Limpar Cache" />
            </ListItemButton>
          </ListItem>

          {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_EXPORTAR_PLANILHA, permissoes$.value) && (
            <ListItem disablePadding>
              <ListItemButton onClick={handleExport}>
                <ListItemIcon>
                  <GetApp />
                </ListItemIcon>
                <ListItemText className="text-menu" primary="Exportar planilha" />
              </ListItemButton>
            </ListItem> 
          )}
              
          <ListItem disablePadding>
            <ListItemButton onClick={onLogout}>
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText className="text-menu" primary="Sair" />
            </ListItemButton>
          </ListItem>
        </Box>
      </Box>
    </Popover>
  );
};

export default MenuUser;
